import React from 'react';
import SignatureModalPad from '../../inspections/InspectionFormBuilderComponents/signatureModalPad';

const SignatureField = ({ value, onChange, disabled = false }) => (
  <div className="signature-field">
    <SignatureModalPad
      initialImage={value}
      disabled={disabled}
      hasExistingSignature={!!value}
      onSave={(image) => onChange?.(image)}
      onClear={() => onChange?.(undefined)}
      onDelete={() => onChange?.(undefined)}
    />
  </div>
);

export default SignatureField;
